import { useBack } from "../http";
import { FormDTO } from "../types/FormDTO";

export class FormService {
	constructor() {}
	axiosInstance = useBack();
	urlDefault = "/form";

	async getForm(id: string | undefined) {
		try {
			const response = await this.axiosInstance
				.get<FormDTO>(`${this.urlDefault}/simplified/${id}`);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter o formulário`, error);
			return undefined;
		}
	}

	async sendAnswer(formId: string | undefined, questionId: number | undefined, answer: string) {
		const body = { answer: answer };
		try {
			const response = await this.axiosInstance
				.post<FormDTO>(`${this.urlDefault}/${formId}/answer/${questionId}`, body);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível enviar a resposta da pergunta ${questionId}`, error);
			return undefined;
		}
	}
}